import React, { FC } from 'react';
import {
  StatusToast,
  StatusToastProps,
  ToastContainer,
} from '@wix/design-system';
import s from './StatusToastNotification.module.scss';

interface Props
  extends Omit<StatusToastProps, 'className' | 'dismissLabel' | 'role'> {
  message: string;
  isMobileView?: boolean;
  show?: boolean;
}

const StatusToastNotification: FC<Props> = ({
  status,
  message,
  isMobileView = false,
  dismissible = false,
  duration = 6000,
  dataHook,
  onDismiss,
  action,
  key,
  show = true,
}) => {
  if (!show) return null;

  return (
    <ToastContainer>
      <StatusToast
        key={key}
        className={`${isMobileView ? s.mobileWidth : ''}`}
        status={status}
        duration={duration}
        dismissible={dismissible}
        onDismiss={onDismiss}
        dataHook={dataHook}
        action={action}
      >
        {message}
      </StatusToast>
    </ToastContainer>
  );
};

export default StatusToastNotification;
